module.exports = __webpack_public_path__ + "static/media/default.f88d112c.jpg";